import { render, staticRenderFns } from "./r-reward-package-table.vue?vue&type=template&id=f3c4ac52"
import script from "./r-reward-package-table.vue?vue&type=script&lang=js"
export * from "./r-reward-package-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3c4ac52')) {
      api.createRecord('f3c4ac52', component.options)
    } else {
      api.reload('f3c4ac52', component.options)
    }
    module.hot.accept("./r-reward-package-table.vue?vue&type=template&id=f3c4ac52", function () {
      api.rerender('f3c4ac52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/reward-pack/r-reward-package-table.vue"
export default component.exports